angular.module('tgaAdmin')
  .controller('ResetController', [
    '$scope', '$state', 'userService', 'settingsService', 'domainService', 'flashService',
    function (
      $scope, $state, userService, settingsService, domainService, flashService,
    ) {
      if (userService.isLoggedIn()) {
        $state.go('v1.games');
      }

      $scope.data = {
        alerts: [],
        logo: '',
        defaultLogo: './v1/assets/images/logo-black.svg',
      };

      $scope.viewmodel = {
        token: $state.params.token,
        password: '',
        confirm: '',
      };

      $scope.initialize = function () {
        settingsService.getSettings().then((settings) => {
          $scope.data.logo = settings.logo || $scope.data.defaultLogo;
        });
      };

      $scope.actions = {
        submit() {
          $scope.data.alerts = [];

          if ($scope.resetForm.$invalid) {
            return;
          }

          if ($scope.viewmodel.password !== $scope.viewmodel.confirm) {
            return;
          }

          $scope.loading = true;

          userService.reset($scope.viewmodel).then(() => {
            flashService.set('<span class="fa fa-check"></span> Password reset successfully.', 'success');
            $state.go('v1.games');
          }, () => {
            $scope.loading = false;
            $scope.actions.createAlert('Unable to reset password.', 'danger');
          });
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };

      $scope.initialize();
    },
  ]);
